import React, { ChangeEvent } from "react";

type CustCodeFieldProps = {
  label: string;
  placeholder?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  facilityCode?: string;
  required?: boolean;
  itemStart?: boolean;
  note: string;
}

const CustCodeField: React.FC<CustCodeFieldProps> = ({ label, placeholder, value, onChange, facilityCode, required = false, itemStart = false, note }) => (
  <div className={`contact-box__item ${itemStart ? 'contact-box__item--start' : ''}`}>
    <label className="contact-box__ttl">
      <span>{label}</span>
      { required && <small>必須</small> }
    </label>
    <div className="contact-box__ct">
      <div className="contact-box__flex">
        <p className="contact-box__desc">{facilityCode}</p>
        <input type="text" className="input input-id" placeholder={placeholder} value={value} onChange={onChange} />
      </div>
      <p className="contact-box__note">{note}</p>
    </div>
  </div>
);

export default CustCodeField;